module.exports = __webpack_public_path__ + "static/img/Ody7zHAPx97fagFcA_340_220.82d280b7.png";